import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import useRequiredFields from "../../../../hooks/useRequiredFields";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import ReactDropdown from "../../../Common/ReactDropdown";

const Edit = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const [location, setLocation] = useState([]);
  const [factory, setFactory] = useState({});
  const { id } = useParams();
  const [error, setError] = useState({});
  const { checkRequiredFields } = useRequiredFields();
  const [loading, setLoading] = useState(false);

  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const [factoryRes, locationRes] = await Promise.all([
          Http.get(`/factory/${id}/edit`),
          Http.get("/locationSelect2"),
        ]);

        setInputs({
          location_id: factoryRes.data.location_id,
          name: factoryRes.data.name,
          status: factoryRes.data.status,
        });

        setSelectedOption({
          label: factoryRes.data.location.name,
          value: factoryRes.data.location.id,
        });

        setLocation(locationRes.data);
        setFactory(factoryRes.data);
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // const fetchData = () => {
  //   Http.get("/factory/" + id + "/edit").then((res) => {
  //     setInputs({
  //       location_id: res.data.location_id,
  //       name: res.data.name,
  //       status: res.data.status,
  //     });
  //     setSelectedOption({
  //       label: res.data.location.name,
  //       value: res.data.location.id,
  //     });
  //   });

  //   Http.get("/locationSelect2").then((res) => {
  //     setLocation(res.data);
  //   });
  // };

  // useEffect(() => {
  //   fetchData();
  // }, []);

  const selectHandleChange = (selectedOption, actionMeta) => {
    setSelectedOption({
      label: selectedOption.label,
      value: selectedOption.value,
    });

    const name = actionMeta.name;
    const value = selectedOption.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const formSubmit = () => {
    if (checkRequiredFields()) {
      // Http.put("/factory/" + id, inputs)
      Http.put(`/factory/${id}`, inputs)
        .then((res) => {
          navigate("/factory", {
            state: { message: res.data.message, type: res.data.type },
          });
        })
        .catch(function (e) {
          setError(e.response.data.errors);
        });
    }
  };

  const reactDropdownHandler = (field, prop) => (e) => {
    setInputs((values) => ({
      ...values,
      [field]: prop ? e.value[prop] : e.value,
    }));
  };

  const findSelectedOption = (options, value, key) => {
    return options.find((item) => item[key] === value);
  };

  const status = [
    { statusName: "Active", statusValue: "active" },
    { statusName: "Inactive", statusValue: "inactive" },
  ];

  return (
    <div>
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create Factory</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Edit Factory Form</h6>
            {loading ? (
              <ProgressSpinner />
            ) : (
              <div>
                <div className="row">
                  <div className="col-lg">
                    <FormValidation error={error} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg">
                    <label className="font-weight-bold">Location</label>
                    {/* <Select
                      className="basic-single"
                      classNamePrefix="select"
                      defaultValue={selectedOption}
                      value={selectedOption}
                      onChange={selectHandleChange}
                      name="location_id"
                      options={location}
                      // options={Array.from(location).map((item, index) => {
                      //   return { ...item, key: index };
                      // })}
                      // onChange={selectHandleChange}
                    /> */}
                    <ReactDropdown
                      options={location}
                      optitle={"label"}
                      val={inputs.location_id}
                      // val={findSelectedOption(factory, inputs.location_id, 'id')}
                      onChange={reactDropdownHandler("location_id")}
                    />

                    {/* <select
                  className="form-control"
                  name="location_id"
                  onChange={handleChange}
                >
                  <option value="">Select Location</option>
                  {Array.from(location).map((item, index) => (
                    <option
                      value={item.id}
                      selected={inputs.location_id === item.id ? true : false}
                    >
                      {item.name}
                    </option>
                  ))}
                </select> */}
                  </div>
                  <div className="col-lg">
                    <label className="font-weight-bold">
                      Name <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={inputs.name || ""}
                      onChange={handleChange}
                      placeholder="Input Name"
                      data-required
                    />
                  </div>

                  <div className="col-lg mg-t-10 mg-lg-t-0">
                    <label className="font-weight-bold">Status</label>
                    {/* <select
                      className="form-control"
                      name="status"
                      onChange={handleChange}
                    >
                      <option
                        value="active"
                        selected={inputs.status === "active" ? true : false}
                      >
                        Active
                      </option>
                      <option
                        value="inactive"
                        selected={inputs.status === "inactive" ? true : false}
                      >
                        inactive
                      </option>
                    </select> */}
                    <ReactDropdown
                      options={status}
                      optitle={"statusName"}
                      val={findSelectedOption(status, inputs.status, 'statusValue')}
                      onChange={reactDropdownHandler("status", "statusValue")}
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Update
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;
